import { initClient, initClientNavigation } from 'rwsdk/client';

// Side-effect import so Vite includes global.css in the client bundle.
// Importing from document.tsx (server-side) runs in the Worker but never
// reaches the browser — Vite needs the import on the client entry to
// inject the stylesheet (dev) and bundle it (prod).
import '@/styles/global.css';

// Client-side hydration entry — dog-os web wedge.
const { handleResponse, onHydrated } = initClientNavigation();
initClient({ handleResponse, onHydrated });
